import {useSignalr} from '@known-as-bmf/react-signalr';
import {useEffect} from 'react';
import {LogLevel} from '@aspnet/signalr';
import {AuthService} from '../services/auth/authService';

export function useTourHub(messageHandler) {
  const {on} = useSignalr(`${process.env.REACT_APP_API_URI}tour-ws/tour-hub`, {
    logger: LogLevel.Error,
    accessTokenFactory() {
      return AuthService.getAuthToken();
    }
  });

  useEffect(() => {
    const sub = on('deletetour').subscribe(next =>
      messageHandler(next)
    );
    return () => sub.unsubscribe();
  }, [on, messageHandler]);
  useEffect(() => {
    const sub = on('updatetour').subscribe(next =>
      messageHandler(next)
    );
    return () => sub.unsubscribe();
  }, [on, messageHandler]);
  useEffect(() => {
    const sub = on('createtour').subscribe(next =>
      messageHandler(next)
    );
    return () => sub.unsubscribe();
  }, [on, messageHandler]);
}
